import { twc } from '~/utils/classnames';

export const Skeleton = twc.div`h-5 animate-pulse rounded-md bg-slate-200`;
